import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pds-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {

  @Input() svgName : string;

  constructor() { }

  ngOnInit(): void {
  }

}
